import { Inject, Injectable } from '@angular/core';
import { UserService } from './user.service';
import { User } from '../model/user.model';
import { HttpErrorResponse, HttpResponse, HttpResponseBase } from '@angular/common/http';
import { ConfigService } from '../../config/config.service';
import { CONSTANTS } from '../../config/constants.module';
import { UserRoles } from '../../../assets/config/shared/user-role.settings';
import {PortalAuthService} from "portal-auth";

@Injectable({
  providedIn: 'root',
})
export class UserPortalService extends UserService {
  constructor(
    protected configService: ConfigService,
    @Inject(CONSTANTS) public readonly CONST: any,
    private readonly portalAuthService: PortalAuthService
  ) {
    super(configService, CONST);
  }

  getUserInfo(): Promise<HttpResponseBase> {
    try {
      if (!this.portalAuthService.authenticated) {
        throw new Error('User not authenticated.');
      }
      // init user
      this._user = new User();
      this._user.userId = this.portalAuthService.user.username;
      this._user.userName = this.portalAuthService.user.fullName;

      this._user.roles = new Array<UserRoles>();

      // init user roles
      this.portalAuthService.groups.forEach(group => {
        if (group.title.includes(this.configService.appConfig.rolePrefix)) {
          const role = group.title as UserRoles;
          if (role) {
            this._user.roles.push(role);
          }
        }
      });

      // create own status for user login success
      const successRes = new HttpResponse({
        status: 200,
        statusText: 'UserService.getUserInfo: successfully get user info',
        url: this.portalAuthService.portal.url,
      });
      return Promise.resolve(successRes);
    } catch (e) {
      // create own status for user login error
      const errRes = new HttpErrorResponse({
        status: this.CONST.HTTP_STATUS.SBB_LOGIN_ERROR,
        statusText: e.message,
        url: this.portalAuthService.portal.url,
      });
      return Promise.resolve(errRes);
    }
  }

  /**
   * checks if logged in user has specific role
   * @param roleTobeChecked the role to be checked
   */
  public userHasRole(roleTobeChecked: string): boolean {
    let userHasRole = false;
    this._user.roles.forEach(role => {
      if (roleTobeChecked === role) userHasRole = true;
    });
    return userHasRole;
  }
}
